import React from 'react';
import { LineChart as LineChartBase } from '@iot-app-kit/charts';
import { useTimeSeriesData } from '../../hooks/useTimeSeriesData';
import { useViewport } from '../../hooks/useViewport';
import { DEFAULT_LEGEND, DEFAULT_VIEWPORT, ECHARTS_GESTURE, } from '../../common/constants';
export const LineChart = (props) => {
    var _a, _b, _c, _d;
    const { queries, thresholds = [], yMin, yMax, axis, viewport: passedInViewport, thresholdSettings, aggregationType, styles, ...rest } = props;
    const { dataStreams, thresholds: queryThresholds } = useTimeSeriesData({
        viewport: passedInViewport,
        queries,
        settings: {
            fetchFromStartToEnd: true,
            fetchMostRecentBeforeStart: true,
        },
        styles,
    });
    const { viewport, setViewport, group, lastUpdatedBy } = useViewport();
    const allThresholds = [...queryThresholds, ...thresholds];
    // if using echarts then echarts gesture overrides passed in viewport
    // else explicitly passed in viewport overrides viewport group
    const utilizedViewport = (_a = (lastUpdatedBy === ECHARTS_GESTURE
        ? viewport
        : passedInViewport || viewport)) !== null && _a !== void 0 ? _a : DEFAULT_VIEWPORT;
    return (React.createElement(LineChartBase, { widgetId: '', dataStreams: dataStreams, axis: {
            showX: (_b = axis === null || axis === void 0 ? void 0 : axis.showX) !== null && _b !== void 0 ? _b : true,
            showY: (_c = axis === null || axis === void 0 ? void 0 : axis.showY) !== null && _c !== void 0 ? _c : true,
            labels: { yAxis: { content: (axis === null || axis === void 0 ? void 0 : axis.yAxisLabel) || '' } },
        }, viewport: { ...utilizedViewport, group, lastUpdatedBy, yMin, yMax }, setViewport: setViewport, annotations: {
            y: allThresholds,
            thresholdOptions: {
                showColor: (_d = thresholdSettings === null || thresholdSettings === void 0 ? void 0 : thresholdSettings.colorBreachedData) !== null && _d !== void 0 ? _d : true,
            },
        }, aggregationType: aggregationType, legend: DEFAULT_LEGEND, ...rest }));
};
